import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { Typography, Select } from 'antd'

import { queryDictItemsApi } from '@eastcoal/api/system/dict/queryDictItems'

import { DataError } from '@eastcoal/common/components/DataError'

import { DictEmpty } from './Empty'
import { DictSelectProps } from './interface'

export const DictSelect = ({
  code,
  allowClear = true,
  labelInValue = false,
  showValue = true,
  ...restProps
}: DictSelectProps) => {
  const {
    error,
    data = [],
    loading,
    refreshAsync
  } = useRequest(() => queryDictItemsApi({ code }, { silence: true }), {
    manual: false,
    ready: !!code
  })

  const options = useMemo(
    () =>
      data.map(({ id, val, label }) => ({
        key: `${id}`,
        value: val,
        label: (
          <>
            {showValue && <span>{val}</span>}
            {!!label && (
              <Typography.Text type={showValue ? 'secondary' : undefined}>
                {label}
              </Typography.Text>
            )}
          </>
        )
      })),
    [data, showValue]
  )

  return error ? (
    <DataError error={error} loading={loading} reload={refreshAsync} />
  ) : (
    <Select
      allowClear={allowClear}
      labelInValue={labelInValue}
      loading={loading}
      options={options}
      notFoundContent={
        <DictEmpty code={code} loading={loading} reload={refreshAsync} />
      }
      {...restProps}
    />
  )
}
